<template>
  <div class="flex flex-col md:flex-row justify-between items-stretch md:items-end mb-4 gap-3">
    <div class="flex flex-1 items-end gap-3">
      <fwb-input
        v-model="searchQuery"
        placeholder="Buscar por ID, título, ubicación"
        class="w-full bg-white border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0"
        @input="onSearch"
      >
        <template #prefix>
          <div>
            <svg aria-hidden="true" class="w-5 h-5 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </svg>
          </div>
        </template>
      </fwb-input>
    </div>

    <TypePropertyFilterComponent
      ref="typePropertyRef"
      v-model="filterTypeProperty"
      :options="props.typeProperty"
      width-class="w-full md:w-fit"
      @open="closeOthers('typeProperty')"
    />

    <TypeMovementFilterComponent
      ref="typeMovementRef"
      v-model="filterTypeMovement"
      :options="props.movements"
      width-class="w-full md:w-fit"
      @open="closeOthers('typeMovement')"
    />

    <TypeStatusFilterComponent
      ref="typeStatusRef"
      v-model="filterTypeStatus"
      :options="props.statusList"
      width-class="w-full md:w-fit"
      @open="closeOthers('typeStatus')"
    />

    <PriceRangeFilter
      ref="priceRangeRef"
      :currency="filterCurrency"
      :min-price="filterMinPrice"
      :max-price="filterMaxPrice"
      dropdown-align="left"
      @update:currency="v => filterCurrency = v"
      @update:minPrice="v => filterMinPrice = v"
      @update:maxPrice="v => filterMaxPrice = v"
      @change="onChangeFilter"
    />
    
    <div class="flex justify-end items-end relative">
      <ToolTipComponent 
        v-if="props.isLimitReached" 
        placement="left"
      >
        <template #content> Has alcanzado el límite de {{ props.propertyLimit }} propiedades </template>
        <button
          @click="$emit('add-property')"
          :disabled="props.isLimitReached"
          :class="[
            'flex items-center space-x-2 text-white p-2 rounded-lg h-[42px] transition-all md:w-auto w-full',
            props.isLimitReached ? 'bg-gray-400 cursor-not-allowed opacity-60' : 'bg-tuin-100 hover:bg-tuin_hover'
          ]"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10 5.5C10.2652 5.5 10.5196 5.60536 10.7071 5.79289C10.8946 5.98043 11 6.23478 11 6.5V9.5H14C14.2652 9.5 14.5196 9.60536 14.7071 9.79289C14.8946 9.98043 15 10.2348 15 10.5C15 10.7652 14.8946 11.0196 14.7071 11.2071C14.5196 11.3946 14.2652 11.5 14 11.5H11V14.5C11 14.7652 10.8946 15.0196 10.7071 15.2071C10.5196 15.3946 10.2652 15.5 10 15.5C9.73478 15.5 9.48043 15.3946 9.29289 15.2071C9.10536 15.0196 9 14.7652 9 14.5V11.5H6C5.73478 11.5 5.48043 11.3946 5.29289 11.2071C5.10536 11.0196 5 10.7652 5 10.5C5 10.2348 5.10536 9.98043 5.29289 9.79289C5.48043 9.60536 5.73478 9.5 6 9.5H9V6.5C9 6.23478 9.10536 5.98043 9.29289 5.79289C9.48043 5.60536 9.73478 5.5 10 5.5Z" fill="white"/>
          </svg>
          <span class="ml-2">Agregar</span>
        </button>
      </ToolTipComponent>

      <button
        v-else
        @click="$emit('add-property')"
        class="flex items-center space-x-2 justify-center md:justify-start text-white bg-tuin-100 hover:bg-tuin_hover p-2 rounded-lg h-[42px] md:w-auto w-full"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M10 5.5C10.2652 5.5 10.5196 5.60536 10.7071 5.79289C10.8946 5.98043 11 6.23478 11 6.5V9.5H14C14.2652 9.5 14.5196 9.60536 14.7071 9.79289C14.8946 9.98043 15 10.2348 15 10.5C15 10.7652 14.8946 11.0196 14.7071 11.2071C14.5196 11.3946 14.2652 11.5 14 11.5H11V14.5C11 14.7652 10.8946 15.0196 10.7071 15.2071C10.5196 15.3946 10.2652 15.5 10 15.5C9.73478 15.5 9.48043 15.3946 9.29289 15.2071C9.10536 15.0196 9 14.7652 9 14.5V11.5H6C5.73478 11.5 5.48043 11.3946 5.29289 11.2071C5.10536 11.0196 5 10.7652 5 10.5C5 10.2348 5.10536 9.98043 5.29289 9.79289C5.48043 9.60536 5.73478 9.5 6 9.5H9V6.5C9 6.23478 9.10536 5.98043 9.29289 5.79289C9.48043 5.60536 9.73478 5.5 10 5.5Z" fill="white"/>
        </svg>
        <span class="ml-2">Agregar</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { FwbInput } from 'flowbite-vue';
import PriceRangeFilter from '@/components/common/PriceRangeFilter.vue';
import TypePropertyFilterComponent from '@/components/properties/components/TypePropertyFilterComponent.vue';
import TypeMovementFilterComponent from '@/components/properties/components/TypeMovementFilterComponent.vue';
import TypeStatusFilterComponent from '@/components/properties/components/TypeStatusFilterComponent.vue';
import ToolTipComponent from "@/components/common/ToolTipComponent.vue";

const props = defineProps({
  typeProperty:  { type: Array,           default: () => [] },
  movements:     { type: Array,           default: () => [] },
  statusList:    { type: Array,           default: () => [] },
  isLimitReached:{ type: Boolean,         default: false },
  propertyLimit: { type: [Number, String],default: null },
});

const emit = defineEmits(['search', 'change-filter', 'add-property']);

const searchQuery         = ref(null);
const filterTypeProperty  = ref([]);
const filterTypeMovement  = ref('');
const filterTypeStatus    = ref('');

const typePropertyRef     = ref(null);
const typeMovementRef     = ref(null);
const typeStatusRef       = ref(null);
const priceRangeRef       = ref(null);

watch(filterTypeProperty, () => onChangeFilter(), { deep: true });
watch(filterTypeMovement, () => onChangeFilter(), { deep: true });
watch(filterTypeStatus, () => onChangeFilter(), { deep: true });

const filterCurrency      = ref('');
const filterMinPrice      = ref('');
const filterMaxPrice      = ref('');

function closeOthers(except) {
  if (except !== 'typeProperty') typePropertyRef.value?.close();
  if (except !== 'typeMovement') typeMovementRef.value?.close();
  if (except !== 'typeStatus')   typeStatusRef.value?.close();
  if (except !== 'price')        priceRangeRef.value?.close();
}

function onSearch() {
  emit('search', searchQuery.value);
}

function onChangeFilter() {
  typePropertyRef.value?.close();
  typeMovementRef.value?.close();
  typeStatusRef.value?.close();
  emit('change-filter', {
    filterTypeOperation: filterTypeMovement.value,
    filterTypeProperty:  filterTypeProperty.value,
    filterTypeStatus:    filterTypeStatus.value,
    filterCurrency:      filterCurrency.value,
    filterMinPrice:      filterMinPrice.value,
    filterMaxPrice:      filterMaxPrice.value,
  });
}
</script>